module.exports = __webpack_public_path__ + "assets/img/4be2cfc852234f30eba04fdd4fdc0fc5.svg";